import Vue from 'vue'
import store from './store'

Vue.directive('page-title', {
    bind(el, binding) {
        store.commit('setPageTitle', binding.value)
    },
})
